import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { errorMessages } from '@core/modules/error/constants';
import { Logger } from '@core/services/logger.service';

import {
  ErrorActionTypes,
  HttpExceptionErrorOccurred,
  ParamsNotValidErrorOccurred,
  UnhandledExceptionErrorOccurred,
} from './error.actions';

const logger = new Logger(module.id);

@Injectable()
export class ErrorEffects {
  authorisationErrorOccurred$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActionTypes.AuthorisationErrorOccurred),
        tap((action) => {
          this.handleError({
            actionType: action,
            message: errorMessages.authorisation,
          });
        })
      ),
    { dispatch: false }
  );

  fatalErrorOccurred$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActionTypes.UnhandledExceptionErrorOccurred),
        tap((action: UnhandledExceptionErrorOccurred) => {
          this.handleError({
            actionType: action.type,
            message: errorMessages.unhandledException,
            error: action.payload.error,
            stack: action.payload.stack,
          });
        })
      ),
    { dispatch: false }
  );

  httpErrorOccurred$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActionTypes.HttpExceptionErrorOccurred),
        tap((action: HttpExceptionErrorOccurred) => {
          this.handleError({
            actionType: action.type,
            message: `${errorMessages.httpError} ${action.payload.message}`,
          });
        })
      ),
    { dispatch: false }
  );

  notFoundErrorOccurred$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActionTypes.NotFoundErrorOccurred),
        tap((action) => {
          this.handleError({
            actionType: action,
            message: errorMessages.notFound,
          });
        })
      ),
    { dispatch: false }
  );

  paramsNotValidErrorOccurred$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActionTypes.ParamsNotValidErrorOccurred),
        tap((action: ParamsNotValidErrorOccurred) => {
          this.handleError({
            actionType: action.type,
            message: action.payload.message,
          });
        })
      ),
    { dispatch: false }
  );

  constructor(private readonly actions$: Actions) {}

  private handleError({
    actionType,
    error,
    message,
    stack,
  }: {
    actionType: ErrorActionTypes;
    error?: Error;
    message: string;
    stack?: string;
  }) {
    logger.error(message, actionType, error, stack);
  }
}
